import { useLocation } from "wouter";
import { AppShell, Divider, NavLink, ScrollArea } from "@mantine/core";
import {
  IconKey,
  IconLogout,
  IconChevronRight,
  IconBuildingFactory,
  IconUserStar,
  IconServerCog,
  IconHome,
  IconTableImport,
  IconWorldDollar,
  IconPackage,
  IconSchema,
  IconTicket,
  IconBook,
} from "@tabler/icons-react";
import { useStore } from "./store";
import { userLogout } from "./api";
import { isNavActive, PARTNER_NAV_HREFS } from "./utils/navActive";

export default function Navbar({ toggle }) {
  const [location, setLocation] = useLocation();
  const authToken = useStore((state) => state.authToken);
  const profile = useStore((state) => state.profile);

  function MyNavLink(item) {
    const active =
      profile?.role === "MarketplacePartner"
        ? isNavActive(location, item.link, PARTNER_NAV_HREFS)
        : location.startsWith(item.link);
    return (
      <NavLink
        label={item.label}
        active={active}
        key={item.label}
        leftSection={<item.icon stroke={1.5} />}
        rightSection={
          item.rightSection ?? <IconChevronRight size="0.8rem" stroke={1.5} />
        }
        onClick={(event) => {
          event.preventDefault();
          item.onClick ? item.onClick() : setLocation(item.link);
          toggle();
        }}
      />
    );
  }

  return (
    <>
      {authToken ? (
        <>
          {profile?.role === "MarketplacePartner" ? (
            <>
              <MyNavLink label="Home" link="/partner" icon={IconHome} />
              <MyNavLink
                label="Codes"
                link="/partner/codes"
                icon={IconTicket}
              />
              <MyNavLink
                label="Merchants"
                link="/partner/merchants"
                icon={IconBuildingFactory}
              />
              <MyNavLink
                label="Playbook"
                link="/partner/playbook"
                icon={IconBook}
              />
            </>
          ) : (
            <>
              <MyNavLink label="Home" link="/home" icon={IconHome} />
              <MyNavLink
                label="Imports"
                link="/imports"
                icon={IconTableImport}
              />
            </>
          )}

          {/* Hidden: PIM features have moved to FacetFlux */}
          {/* <Divider label="PIM" />
          <MyNavLink label="Products" link="/pim/products" icon={IconPackage} />
          <MyNavLink label="Schemas" link="/pim/schemas" icon={IconSchema} /> */}

          <AppShell.Section component={ScrollArea}>
            {profile?.role == "GlobalAdmin" && (
              <>
                <Divider label="Admin" />
                <MyNavLink
                  label="Users"
                  link="/admin/users"
                  icon={IconUserStar}
                />
                <MyNavLink
                  label="Tenants"
                  link="/tenants"
                  icon={IconBuildingFactory}
                />
                <MyNavLink
                  label="Partners"
                  link="/admin/partners"
                  icon={IconUserStar}
                />
                <MyNavLink
                  label="Jobs"
                  link="/admin/jobs"
                  icon={IconServerCog}
                />
                <MyNavLink
                  label="Marketplaces"
                  link="/marketplaces"
                  icon={IconWorldDollar}
                />
                <MyNavLink
                  label="Signup Codes"
                  link="/admin/signup-codes"
                  icon={IconTicket}
                />
              </>
            )}
          </AppShell.Section>
          <AppShell.Section grow></AppShell.Section>
          <AppShell.Section>
            <MyNavLink label="Logout" icon={IconLogout} onClick={userLogout} />
          </AppShell.Section>
        </>
      ) : (
        <AppShell.Section component={ScrollArea}>
          <MyNavLink label="Login" link="auth/login" icon={IconKey} />
        </AppShell.Section>
      )}
    </>
  );
}
